import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/toggles")({
  component: lazyRouteComponent(() => import("./-pages/admin.toggles")),
  head: () => ({ meta: [{ title: "Lecmo · مفاتيح التفعيل" }] }),
});
